"use client";

/**
 * Google Tag Manager and GA4 scripts.
 * Same GTM container (GTM-PLBQ4XWH) and GA4 ID (G-DTQ6JYMKV3) as old VidSeeds
 * for continuity when replacing on the same domain.
 */

import Script from "next/script";
import { useEffect } from "react";
import { initGtagLoader } from "@/lib/analytics/gtagLoader";

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? "GTM-PLBQ4XWH";

export function GoogleTagManager() {
  useEffect(() => {
    initGtagLoader();
  }, []);

  return (
    <>
      {/* Google Tag Manager - head */}
      <Script
        id="gtm-script"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode&&f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${GTM_ID}');
          `.trim(),
        }}
      />

      {/* Google Tag Manager - noscript fallback */}
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${GTM_ID}`}
          height="0"
          width="0"
          style={{ display: "none", visibility: "hidden" }}
          title="Google Tag Manager"
        />
      </noscript>
    </>
  );
}
